import React, { useState } from "react";
import * as changeCase from "change-case";
import { DataImportTable } from "../data-import-table";
import { Configuration } from "./configuration";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Menu, Button, Space } from "antd";
import { VpdDataImportType } from "../../../graphql/__generated_types__/globalTypes";

export const ReferenceData: React.FC = () => {
  const [selectedDataImportType, setDataImportType] = useState<VpdDataImportType>(
    VpdDataImportType.OrganisationalUnit
  );
  const selectedConfiguration = Configuration.get(selectedDataImportType);
  const sentanceCaseEnum = changeCase.sentenceCase(selectedDataImportType);

  const handleMenuItemClick = (importType: VpdDataImportType) => {
    setDataImportType(importType);
  };
  return (
    <div>
      <Dropdown
        overlay={
          <Menu onClick={({ key }) => handleMenuItemClick!(key as VpdDataImportType)}>
            {Array.from(Configuration.keys()).map((value) => (
              <Menu.Item style={{ padding: 3 }} key={value}>
                {changeCase.sentenceCase(value)}
              </Menu.Item>
            ))}
          </Menu>
        }
      >
        <Button>
          <Space>
            {sentanceCaseEnum}
            <DownOutlined />
          </Space>
        </Button>
      </Dropdown>
      {selectedConfiguration && (
        <DataImportTable
          columns={selectedConfiguration.columns}
          importType={selectedDataImportType}
          labels={{
            importButtonLabel: `Import ${sentanceCaseEnum}`,
            emptyText: `No ${sentanceCaseEnum} imported yet.`,
            loadingText: `Loading ${sentanceCaseEnum}...`,
          }}
        />
      )}
    </div>
  );
};
